class CaloriesCalculator extends BaseCalculator {
  constructor(formulas) {
    super(formulas);

    this.kcalTargetFactor = {
      0: 0,
      1: 0, 
      2: 0,
    };

    this.proteinTargetFactor = {
      0: 1.75,
      1: 1.75, 
      2: 2,
    };

    this.fatTargetFactor = {
      0: 0.3,
      1: 0.3,
      2: 0.3,
    };

    this.result = {
      kcal: 0,
      protein: 0,
      carbohydrates: 0,
      fat: 0,
    };
  }

  calculate() {
    this._debug();

    const gender = this.getGender();
    const target = this.getTarget();

    const kcalType = gender == 1 ? "kcal_female" : "kcal_male";
    this.result.kcal = this._calculateMetric(kcalType, this.kcalTargetFactor[target], Math.round);

    this.result.protein = this._calculateMetric("protein", this.proteinTargetFactor[target], Math.floor);

    this.result.fat = this._calculateMetric("fat", this.fatTargetFactor[target], Math.floor);

    this.result.carbohydrates = this._calculateMetric("carbohydrates", null, Math.floor);
  }

  _calculateMetric(type, targetFactor, roundFunction) {
    const formula = this.getFormularByType(type);
    if (!formula) return 0;

    let formulaString = formula.formula;
    if (targetFactor !== null) {
      formulaString = formulaString.replaceAll("[[TARGET]]", targetFactor);
    }

    return roundFunction(eval(this._prepareFormular(formulaString)));
  }

  valid() {
    const requiredFields = ['target', 'activity', 'weight', 'size', 'age', 'gender'];
    return requiredFields.every(field => {
      const value = this.getValueByTarget(field);
      return value !== null && value !== "";
    });
  }
}
